import React,{useState, useEffect} from 'react';
import {FaChevronCircleUp} from "react-icons/fa"


function ScrollToTopButton() {
    const [showBtn, setShowBtn] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", function () {
            if (window.scrollY > 800) {
                setShowBtn(true);
            } else {
                setShowBtn(false);
            }
        })

    }, [])
    const ScrollToTop = () => {
        window.scroll({ top: 0, behavior: "smooth" })
    }
    return (
        <div>
            <button onClick={ScrollToTop} className={`fixed bottom-2 right-2 z-50 sm:bottom-4 sm:right-4 transition-opacity duration-300 ${showBtn ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
                <FaChevronCircleUp size={30} style={{color:"#014b85", }}/>
            </button>
        </div>
    );
}

export default ScrollToTopButton;